var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUggLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 2.595v11.328l-.552.369C9.776 15.409 7.892 16 6 16c-1.892 0-3.775-.59-5.448-1.708L0 13.923V2.595l2.478-1.094v11.064c1.13.637 2.314.96 3.522.96 1.208 0 2.393-.323 3.522-.96V1.501zM7.175.548v8.101a4.48 4.48 0 01-1.238.178c-.415 0-.829-.06-1.24-.178V.548L5.938 0z"
  })));
}
export default __webpack_public_path__ + "static/svg/ugg-logo.svg";
export { SvgUggLogo as ReactComponent };